module.exports = __webpack_public_path__ + "static/media/car-5.8e412d18.png";